export const logEnv = (mode: string): void => {
  if (mode === 'production') {
    console.log('🚀 ~ 正在打包【生产环境】')
  } else if (mode === 'development') {
    console.log('🚀 ~ 正在打开【开发环境】')
  } else if (mode === 'staging') {
    console.log('🚀 ~ 正在打开【演示环境】')
  } else {
    console.log('🚀 ~ 正在打开【mode】')
  }
}
